module.exports = __webpack_public_path__ + "img/horizontal_7_3_8017.a7dcb2ca.png";